var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404 noPadding"},[_c('p',{staticClass:"page404_p0"},[_vm._v("所在食堂已过期，请联系代理商开通/续费！")]),_c('router-link',{attrs:{"to":"/logout"}},[_c('a-button',{on:{"click":_vm.logOut}},[_vm._v("退出")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }